import React, { useState, useContext } from "react";
import axios from "axios";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";
import { AuthContext } from './Context';
import logo from "../Images/SMJ_Logo.png";
import './Login.css';
import baseURL from "../../../Url/NodeBaseURL";
import { Col, Row, Button, Table, Modal } from 'react-bootstrap';

function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  const navigate = useNavigate();
  const { login, userId, userName } = useContext(AuthContext);

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  const handleLogin = async (e) => {
    e.preventDefault();
    setErrorMessage('');

    if (!email || !password) {
      setErrorMessage('Please provide both email and password.');
      return;
    }

    try {
      const response = await axios.post(`${baseURL}/login`, { email, password });
      console.log("response=", response.data);

      if (response.data.success) {
        const { user } = response.data; // Full user object returned from backend

        // Call the login function from context
        login(user.id, user.role, user.user_name);

        // Store all user details in localStorage
        localStorage.setItem('user', JSON.stringify(user));

        Swal.fire({
          title: 'Update Rates?',
          text: 'Do you want to update rates?',
          icon: 'question',
          showCancelButton: true,
          confirmButtonText: 'Yes, update rates',
          cancelButtonText: 'No, go to dashboard',
        }).then((result) => {
          if (result.isConfirmed) {
            navigate('/rates');
          } else {
            navigate('/dashboard');
          }
        });
      } else {
        setErrorMessage(response.data.message || 'You do not have admin access.');
      }
    } catch (error) {
      const errorMessage =
        error.response?.data?.message || 'An error occurred. Please try again.';
      setErrorMessage(errorMessage);
    }
  };



  return (
    <div className="container-fluid vh-100 d-flex align-items-center justify-content-center bg-light">
      <div
        className="row shadow-lg rounded-4 overflow-hidden w-100"
        style={{
          maxWidth: "950px",
          background: "linear-gradient(135deg, #ffffff 60%, #fff5eb 100%)",
        }}
      >
        {/* Left Side - Logo */}
        <div className="col-md-5 d-flex flex-column align-items-center justify-content-center p-5 bg-white">
          <img
            src={logo}
            alt="Logo"
            className="img-fluid mb-4"
            style={{
              width: "250px",
              height: "250px",
              filter: "drop-shadow(0 4px 8px rgba(0,0,0,0.1))",
            }}
          />

        </div>

        {/* Right Side - Login Form */}
        <div className="col-md-7 p-5 d-flex flex-column justify-content-center bg-white ">
          <h3 className="text-center mb-1 fw-semibold text-dark welcome">Welcome Back!</h3>
          <p className="text-muted text-center">
            Sign in to access your dashboard
          </p>
          {errorMessage && (
            <div className="alert alert-danger py-2 text-center">{errorMessage}</div>
          )}

          <form onSubmit={handleLogin} className="position-relative">
            {/* Email */}
            <div className="mb-4">
              <label htmlFor="email" className="form-label fw-medium">
                Email address
              </label>
              <input
                type="email"
                className="form-control form-control-lg"
                id="email"
                placeholder="Enter your email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
            </div>

            {/* Password */}
            <div className="mb-4 position-relative">
              <label htmlFor="password" className="form-label fw-medium">
                Password
              </label>
              <input
                type={showPassword ? "text" : "password"}
                className="form-control form-control-lg"
                id="password"
                placeholder="Enter your password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />
              <i
                className={`bi ${showPassword ? "bi-eye-slash-fill" : "bi-eye-fill"
                  }`}
                onClick={togglePasswordVisibility}
                style={{
                  position: "absolute",
                  right: "15px",
                  top: "68%",
                  transform: "translateY(-50%)",
                  cursor: "pointer",
                  color: "gray",
                  fontSize: "1.2rem",
                }}
              ></i>
            </div>

            {/* Login Button */}
            <button
              type="submit"
              className="btn btn-warning w-100 fw-bold py-2 text-white"
              style={{
                backgroundColor: "#ff7b00",
                fontSize: "1.1rem",
                boxShadow: "0 4px 10px rgba(255,123,0,0.4)",
              }}
            >
              Login
            </button>
            <Row className="mb-3 mt-4">
              <Col className="text-center">
                <div style={{ fontSize: '1rem', whiteSpace: 'nowrap' }}>
                  <span
                    onClick={() => navigate('/forgot-password')}
                    style={{
                      color: "black",
                      fontSize: "1.1rem",
                      cursor: 'pointer',
                    }}
                  >
                    Forgot Password?
                  </span>
                </div>
              </Col>
            </Row>

          </form>
        </div>
      </div>
    </div>
  );
}

export default Login;
